import React from 'react';
import { Dotdotdot, Video } from 'components';
import * as styles from './PostListItem.scss';

function PostListContent(props) {
  var imgs = props.images;
  var multiImgTags = null;

  if (imgs.length > 1) {
    multiImgTags = imgs.map(function (url) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.itemImage
      }, /*#__PURE__*/React.createElement("img", {
        src: "".concat(url)
      }));
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.postListContentWrap,
    style: props.style
  }, multiImgTags ? /*#__PURE__*/React.createElement("div", {
    className: "draftItemPreviewImgContainer"
  }, multiImgTags) : props.image && !props.videoUrl && /*#__PURE__*/React.createElement("div", {
    className: styles.itemImage
  }, /*#__PURE__*/React.createElement("img", {
    src: props.image
  }), props.numImgs && props.numImgs > 1 ? /*#__PURE__*/React.createElement("div", null, "+ ", props.numImgs - 1, " more") : null), props.videoUrl && /*#__PURE__*/React.createElement("div", {
    className: styles.itemImage
  }, /*#__PURE__*/React.createElement(Video, {
    controls: true,
    src: "".concat(props.videoUrl, "#t0.1"),
    style: {
      width: '100%',
      height: '100%'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.itemMessage,
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, props.clampMessage ? /*#__PURE__*/React.createElement(Dotdotdot, {
    clamp: props.numberOfLines
  }, props.message) : /*#__PURE__*/React.createElement("div", null, props.message), props.belowMessageContent && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 8,
      fontSize: 12
    }
  }, props.belowMessageContent), props.suggestedPublishAtRender && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 8,
      fontSize: 12
    }
  }, props.suggestedPublishAtRender)));
}

PostListContent.defaultProps = {
  style: {},
  videoUrl: null,
  image: null,
  images: [],
  message: '',
  belowMessageContent: null,
  suggestedPublishAtRender: null,
  clampMessage: false,
  numberOfLines: 4
};
export default PostListContent;